import { Text, View } from "@react-pdf/renderer";

function SixthRow({ physical }) {
  function formatDate(inputDate) {
    if (!inputDate) {
      return "";
    }

    if (typeof inputDate === 'string' && inputDate.match(/^\d{4}-\d{2}-\d{2}/)) {
      const [year, month, day] = inputDate.substring(0, 10).split('-');
      return `${month}/${day}/${year}`;
    }

    const date = new Date(inputDate);
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${month}/${day}/${year}`;
  }

  return (
    <View style={{ flexDirection: "row", height: "40px" }}>
      <View
        style={{
          width: "4%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Text style={{ textAlign: "center" }}>D</Text>
      </View>
      <View
        style={{
          width: "25%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
        }}
      >
        {physical && (
          <Text style={{ padding: "8px", fontSize: "8px" }}>
            Automobile Physical Damage
          </Text>
        )}
      </View>
      <View
        style={{
          width: "4%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      ></View>
      <View
        style={{
          width: "4%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      ></View>
      <View
        style={{
          width: "18%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Text style={{ textAlign: "center" }}>
          {physical && physical.policy_number}
        </Text>
      </View>
      <View
        style={{
          width: "9%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Text style={{ textAlign: "center" }}>
          {physical && formatDate(physical.policy_effective_date)}
        </Text>
      </View>
      <View
        style={{
          width: "9%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Text style={{ textAlign: "center" }}>
          {physical && formatDate(physical.policy_expiration_date)}
        </Text>
      </View>
      <View style={{ width: "29%", borderBottom: "1px solid black" }}>
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            height: "100%",
            fontFamily: "Helvetica",
          }}
        >
          <View
            style={{
              flex: "1",
              borderRight: "1px solid black",
              height: "100%",
              fontSize: "5px",
            }}
          >
            <Text
              style={{
                paddingLeft: "2px",
                paddingTop: "13px",
                height: "100%",
              }}
            >
              LIMIT
            </Text>
          </View>
          <View style={{ flex: "1", fontSize: "6px" }}>
            <View
              style={{
                flexDirection: "row",
                paddingTop: "11px",
                height: "100%",
              }}
            >
              {physical && (
                <>
                  <Text
                    style={{ paddingHorizontal: "2px", textAlign: "center" }}
                  >
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(physical.limit)}
                  </Text>
                </>
              )}
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}
export default SixthRow;
